import { memo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import "./FavoriteBadge.scss";
import { HeartFilledIcon } from "app/icons/navigation";

const FavoriteBadge = ({ colored = true, hideLabel = false }) => {
	const badgeClass = classNames("favorite-badge", {
		"favorite-badge--colored": colored,
	});
	return (
		<div className={badgeClass} data-testid="favorite-badge">
			<HeartFilledIcon data-testid="icon-coup-de-coeur" />
			{!hideLabel && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.SMALL}
					isBold
					className="favorite-badge__label"
				>
					<FormattedMessage id="product.isFavorite" />
				</Typography>
			)}
		</div>
	);
};

FavoriteBadge.propTypes = {
	colored: PropTypes.bool,
	hideLabel: PropTypes.bool,
};

export default memo(FavoriteBadge);
